import { gql, useMutation } from "@apollo/client";
import { CallMeInput } from "../types/types";

const CALL_ME_MUTATION = gql(`
  mutation CallMe($input: CallMeInput!) {
      callMe(input: $input)
  }
`);

export function useCallMe() {
  const [mutation, info] = useMutation(CALL_ME_MUTATION);
  const callMe = async (input: CallMeInput) => {
    const { data } = await mutation({
      variables: { input },
    });
    return data;
  }
  return [callMe, info] as const;
}